import { ChakraProvider } from '@chakra-ui/react';
import { lightTheme } from '@mediwareinc/wellsky-dls-react';

export const ChakraWrapper = ({ children }) => (
  <ChakraProvider theme={lightTheme}>
    {children}
  </ChakraProvider>
);
